import { Contrato } from './contrato.entity';
import { UsuarioOnline } from './UsuarioOnline.entity';
export class Domiciliacion
    {
        UsuarioOnline: UsuarioOnline;
        Contrato: Contrato;
        TipoSolicitud: string;
        Poblacion: string;
    }


// WEBPACK FOOTER //
// C:/Users/jboix/source/repos/classic/OficinaAngular/src/app/entities/domiciliacion.entity.ts